module.exports = __webpack_public_path__ + "media/assets/images/result-polyline-ec253c7fa6c6097a914b9fe6a1bba10a.svg";